/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MachineVariableMetricDTO { 
    timestamp?: string;
    value?: number;
    rating?: number;
    unit?: string;
    machine_variable?: string;
}

